import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";

import { MdChevronLeft, MdChevronRight } from "react-icons/md";

import Canal from './Canal.jsx'

function CanaisLista({ canaislist }) {

    const barref = useRef();

    const btesquerda = (barra) => {
        barra.scrollLeft -= 300
    }
    const btdireita = (barra) => {
        barra.scrollLeft += 300
    }

    return (
        <div className="relative">
            {/* Navigation Arrows - Only visible on desktop */}
            <button
                className='hidden md:flex items-center justify-center absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full cursor-pointer z-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500'
                onClick={() => { btesquerda(barref.current) }}
                aria-label="Ver conteúdo anterior"
            >
                <MdChevronLeft className="text-xl" />
            </button>
            
            <button
                className='hidden md:flex items-center justify-center absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full cursor-pointer z-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500'
                onClick={() => { btdireita(barref.current) }}
                aria-label="Ver próximo conteúdo"
            >
                <MdChevronRight className="text-xl" />
            </button>

            {/* Carousel Container - Mobile First Responsive */}
            <div 
                className='flex gap-3 md:gap-4 overflow-x-auto scrollbar-hide scroll-smooth px-2 md:px-12 py-2 md:py-4'
                ref={barref}
                role="region"
                aria-label="Lista de canais"
            >
                {canaislist.map((item, index) => (
                    <div key={index} className="flex-shrink-0">
                        <Link 
                            to={`/Canal/${item.linktoken}`}
                            className="block focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-slate-950 rounded-lg"
                            aria-label={`Assistir ${item.username}`}
                        >
                            <Canal item={item} />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CanaisLista